import {Component, Input, OnInit} from '@angular/core';
import { IotDevicesParse} from "../../ParseClass/Iotdevices.Parse";

@Component({
    selector: 'app-box-io-tdevice',
    templateUrl: './box-io-tdevice.component.html',
    styleUrls: ['./box-io-tdevice.component.scss'],
    standalone: false
})
export class BoxIoTDeviceComponent implements OnInit {
    @Input() device: IotDevicesParse | undefined
    @Input() disabled = false;

    constructor() {
    }

    ngOnInit(): void {
    }

    getValue(device: IotDevicesParse, label: keyof IotDevicesParse) {
        const value = device[label];
        return value
        // const ND = this.translateService.instant('NaN');
        //   return ND;
    }
}
